module.exports = __webpack_public_path__ + "img/pictures.01f06d0b.jpg";